import { render, staticRenderFns } from "./Tv3.vue?vue&type=template&id=701d2738&"
import script from "./Tv3.vue?vue&type=script&lang=js&"
export * from "./Tv3.vue?vue&type=script&lang=js&"
import style0 from "./Tv3.vue?vue&type=style&index=0&id=701d2738&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports